import { ENTRY_ROUTE_MARKS, type RouteMark } from '@daghfal/core';

/**
 * Every route `App.tsx` declares, marked where its screen shows a child's data, which the shell then draws
 * under the viewer watermark (Q40, Q49). A route added to `App.tsx` and not here fails
 * `routeMarks.test.ts`, so a new screen cannot ship unmarked by accident.
 */
export const STAFF_ROUTES: readonly RouteMark[] = [
  ...ENTRY_ROUTE_MARKS,
  // The class roster, with the children's photos.
  { route: 'index', path: '/', childData: true },
  { route: 'child/:childId', path: '/child/:childId', childData: true },
  // An incident being recorded, and the record once it is.
  { route: 'child/:childId/incident', path: '/child/:childId/incident', childData: true },
  // Each child's medication in force today, and the doses given.
  { route: 'medications', path: '/medications', childData: true },
  // Several children's names and allergies, for one entry recorded for them all.
  { route: 'group', path: '/group', childData: true },
  { route: 'attendance', path: '/attendance', childData: true },
  { route: 'messages', path: '/messages', childData: true },
  // The picture about to be uploaded, before anyone has published it.
  { route: 'child/:childId/photo', path: '/child/:childId/photo', childData: true },
  // The pictures this teacher uploaded, with who is in each.
  { route: 'photos', path: '/photos', childData: true },
  // The nursery's closures, holidays and trips: no child is named.
  { route: 'calendar', path: '/calendar', childData: false },
  { route: 'notifications', path: '/notifications', childData: false },
  { route: 'account', path: '/account', childData: false },
  // Care entries waiting to be sent: what each child ate, slept, needed.
  { route: 'queue', path: '/queue', childData: true },
  { route: '*', path: '*', childData: false },
];
